module.exports = __webpack_public_path__ + "img/logo.5efa86b2.svg";